module.exports = "/_next/static/images/favicon-61e595d2b5d68eb9386af5017c090fcf.png";